module.exports = __webpack_public_path__ + "static/media/mlops-skills-badge.1.227f1e97.png";